<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.mar_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="mar_decode">
            <label class="weui-form-preview__label">{{
              customLabel.mar_decode || "需求单号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_decode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_name">
            <label class="weui-form-preview__label">{{
              customLabel.de_name || "项目名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_name
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_custname">
            <label class="weui-form-preview__label">{{
              customLabel.de_custname || "需求来源"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_product_type">
            <label class="weui-form-preview__label">{{
              customLabel.de_product_type || "产品类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_product_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_emname">
            <label class="weui-form-preview__label">{{
              customLabel.de_emname || "需求人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="de_dpname">
            <label class="weui-form-preview__label">{{
              customLabel.de_dpname || "需求部门"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.de_dpname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_project_classify">
            <label class="weui-form-preview__label">{{
              customLabel.mar_project_classify || "项目分类"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_project_classify
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_project_level">
            <label class="weui-form-preview__label">{{
              customLabel.mar_project_level || "项目等级"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_project_level
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_emname">
            <label class="weui-form-preview__label">{{
              customLabel.mar_emname || "项目负责人"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_emname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_budget">
            <label class="weui-form-preview__label">{{
              customLabel.mar_budget || "项目预算金额"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_budget
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_currency">
            <label class="weui-form-preview__label">{{
              customLabel.mar_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_currency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_market_analyse">
            <label class="weui-form-preview__label">{{
              customLabel.mar_market_analyse || "行业与市场分析"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_market_analyse
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_products_analyse">
            <label class="weui-form-preview__label">{{
              customLabel.mar_products_analyse || "竞争对手/竞品对标分析"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_products_analyse
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="mar_potential_risk">
            <label class="weui-form-preview__label">{{
              customLabel.mar_potential_risk || "潜在风险"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.mar_potential_risk
            }}</span>
          </div>
        </custom-layout>
      </div>

      <file-list v-model="form.main.mar_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/plm/market_report_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/plm/marketAnalyseReport",
      codeField: "mar_code",
      statusField: "mar_statuscode",
      caller: "MarketAnalyseReport",
      xtype: "plm-marketanalysereport-formpanel",
    };
  },
};
</script>
